<template />

<script>
export default {
  name: 'Referral',
  props: {
    referralId: String
  },
  mounted () {
    this.$router.push({ name: 'register', query: { referral_id: this.referral_id } })
  }
}
</script>

<style scoped>

</style>
